import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, GridItem, Text } from '@chakra-ui/react'
import { PriceBox, Sticky, LimitedOfferBadge } from 'src/uikit'
import Actions, { OfferActionsProps } from 'src/components/OfferDetails/Actions'

interface Props {
  visible: boolean
  subtitle: string
  priceValue: string
  priceDescription: string
}

const StickyBar: FC<Props & OfferGlobal.OfferDetails & OfferActionsProps> = ({
  visible,
  sectionTitle,
  subtitle,
  priceValue,
  priceDescription,
  durationTitle,
  durationValue,
  distanceValue,
  distanceTitle,
  depositValue,
  depositTitle,
  expirationValue,
  active,
  primary,
  hasSecondaryAction,
  secondary
}) => {
  const { t } = useTranslation()

  return (
    <Sticky visible={visible} padding="1rem">
      <Grid
        templateColumns={{ base: '1fr 2.4fr', md: 'repeat(12, 1fr)' }}
        templateRows={{ base: 'repeat(2, 1fr)', md: '1fr' }}
        gap="3"
        width="100%"
      >
        <GridItem
          marginY="auto"
          textAlign="left"
          colSpan={3}
          display={{ base: 'none', md: 'block' }}
        >
          <Text
            color="baseDark"
            fontFamily="Montserrat-SemiBold"
            fontSize="1.375rem"
            lineHeight="28.6px"
            letterSpacing="0.6px"
            mb="xxs"
          >
            {sectionTitle}
          </Text>
          <Text
            color="baseNeutral.700"
            fontFamily="Montserrat-Regular"
            fontSize="0.875rem"
            lineHeight="18px"
            letterSpacing="0.2px"
            marginTop="0rem!important"
          >
            {subtitle}
          </Text>
        </GridItem>
        <GridItem
          marginY="auto"
          mt="2px"
          textAlign="left"
          colSpan={{ base: 5, md: 4 }}
          display={{ base: 'none', md: 'block' }}
        >
          <Box mb="xs">
            <Text
              color="baseDark"
              fontFamily="Montserrat-SemiBold"
              fontSize="1rem"
              lineHeight="20.8px"
              letterSpacing="0.2px"
              display="inline"
            >
              {t('offerContainer:sectionTitle')}
            </Text>
            {expirationValue &&
              <LimitedOfferBadge display="inline" float="right">
                solo {expirationValue} GIORNI
              </LimitedOfferBadge>
            }
          </Box>
          <Text
            color="baseDark"
            fontFamily="Montserrat-Medium"
            fontSize=".75rem"
            letterSpacing="0.3px"
          >
            {`${durationTitle} ${durationValue} | ${distanceValue} ${distanceTitle} | ${depositTitle} ${depositValue}`}
          </Text>
        </GridItem>
        <GridItem textAlign="left">
          <PriceBox value={priceValue} description={priceDescription} />
        </GridItem>
        <GridItem
          marginY="auto"
          marginX={{ base: '', md: 'xxl' }}
          mr="-3"
          textAlign={{ base: 'right', md: 'left' }}
          w={{ base: '', md: '30rem' }}
          display={{ base: 'block', md: 'none' }}
        >
          <Text
            color="baseDark"
            fontFamily="Montserrat-Medium"
            fontSize=".75rem"
            letterSpacing="0.3px"
          >
            {`${durationTitle} ${durationValue} | ${distanceValue} ${distanceTitle}`}
          </Text>
          <Text
            color="baseDark"
            fontFamily="Montserrat-Medium"
            fontSize=".75rem"
            letterSpacing="0.3px"
          >
            {`${depositTitle} ${depositValue}`}
          </Text>
        </GridItem>
        <GridItem
          colSpan={{ base: 3, md: 4 }}
          textAlign={{ base: 'center', md: 'right' }}
          marginLeft={{ base: '0', md: '0.34rem' }}
        >
          <Actions
            active={active}
            primary={primary}
            hasSecondaryAction={hasSecondaryAction}
            secondary={secondary}
            inline
          />
        </GridItem>
      </Grid>
    </Sticky>
  )
}

export default StickyBar
